<template>
  <svg
    width="28"
    height="50"
    viewBox="0 0 28 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 12C10.007 19.9935 17.955 28.0456 26.0009 36"
      stroke="black"
      stroke-width="2.6"
    />
    <path
      d="M26.001 12C17.994 19.9935 10.046 28.0456 2.00004 36"
      stroke="black"
      stroke-width="2.6"
    />
  </svg>
</template>
<script>
export default {
  name: "ArrowAsLink",
};
</script>
<style scoped>
svg.Close {
  width: 28px;
}

path {
  stroke: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/Close.vue